import type { IpAllowlistEntry, PartnerCredential, PartnerDetail } from './types';

export const partnerFixtures: readonly PartnerDetail[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000101',
    code: 'PTN-A',
    name: 'Alpha Partner',
    centerAgentId: '00000000-0000-4000-8000-000000000401',
    affiliateCommissionExpiryDays: 30,
    defaultCurrencyCode: 'THB',
    timezone: 'Asia/Bangkok',
    usernameNormalizationMode: 'LOWERCASE_NFKC',
    status: 'ACTIVE',
    requestRateLimitPerMinute: 100,
    withdrawalRateLimitPerMinute: 10,
    timestampToleranceSeconds: 300,
    createdAt: '2026-07-20T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-22T12:00:00+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000102',
    code: 'PTN-B',
    name: 'Beta Partner',
    centerAgentId: null,
    affiliateCommissionExpiryDays: null,
    defaultCurrencyCode: 'USD',
    timezone: 'Asia/Singapore',
    usernameNormalizationMode: 'EXACT_NFKC',
    status: 'SUSPENDED',
    requestRateLimitPerMinute: 80,
    withdrawalRateLimitPerMinute: 8,
    timestampToleranceSeconds: 180,
    createdAt: '2026-07-18T03:00:00Z',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-21T04:30:00Z',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  }),
]);

export const partnerCredentialFixtures: readonly PartnerCredential[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000201',
    partnerId: partnerFixtures[0]!.id,
    keyId: `pk_${'A'.repeat(32)}`,
    status: 'ACTIVE',
    validFrom: '2026-07-20T00:00:00Z',
    expiresAt: '2027-07-20T00:00:00Z',
    revokedAt: null,
    revokedBy: null,
    revocationReason: null,
    lastUsedAt: '2026-07-22T11:00:00Z',
    createdAt: '2026-07-20T00:00:00Z',
    createdBy: '00000000-0000-4000-8000-000000000001',
  }),
]);

export const partnerIpAllowlistFixtures: readonly IpAllowlistEntry[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000000301',
    partnerId: partnerFixtures[0]!.id,
    network: '203.0.113.0/24',
    status: 'ACTIVE',
    description: 'Primary office',
    createdAt: '2026-07-20T00:00:00Z',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-20T00:00:00Z',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  }),
]);
